import {translation} from "@2d-front-monorepo/core";
import React, {JSX, memo} from "react";
import {permitStatusLabel, permitStatusName} from "../helpers/enumNaming";
import {PermitResult} from "../index";

function PermitStatusComponent({permit}: { permit: PermitResult }): JSX.Element {
	const pillClass = ` pill__permit-status--${permitStatusName(permit.status.type)}`;
	return (<div className={"pill" + pillClass}>{translation(permitStatusLabel(permit.status.type))}</div>);
}

const MemoizedPermitStatusComponent: React.FC<{ permit: PermitResult }> = memo(PermitStatusComponent);
export default MemoizedPermitStatusComponent;
